import { HttpResponse } from '@angular/common/http';

/** Saves an export answered by Julia under the file name it gives (else `fallback`). */
export class BlockDownload {

  static save(response: HttpResponse<Blob>, fallback: string) {
    const match = response.headers.get('Content-Disposition')?.match(/filename="([^"]+)"/);
    const url = URL.createObjectURL(response.body!);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = match ? match[1] : fallback;
    anchor.click();
    URL.revokeObjectURL(url);
  }

  static fileName(alias: string): string {
    return `${alias.replace('#', '-')}.xlsx`;
  }
}
